import {
  CommonFeatureServiceDependencies,
  CommonFeatureServices,
  useFeatureAppEnvironment,
} from '../contexts/feature-app-environment-context';

export function useFeatureService<
  ServiceId extends keyof CommonFeatureServiceDependencies = CommonFeatureServices
>(serviceId: ServiceId): CommonFeatureServiceDependencies[ServiceId] {
  const {featureServices} = useFeatureAppEnvironment();

  return featureServices[serviceId];
}

/**
 * Helper function to set up a `useBrandFeatureService` that takes additional
 * brand-specific dependencies into account.
 *
 * Make sure these dependencies are passed into `createFeatureAppDefinition`!
 */
export function createUseBrandFeatureService<
  BrandFeatureServices extends Record<string, unknown>
>() {
  function useBrandFeatureService<ServiceId extends keyof BrandFeatureServices>(
    serviceId: ServiceId
  ): BrandFeatureServices[ServiceId] {
    const {featureServices} = useFeatureAppEnvironment<BrandFeatureServices>();

    return featureServices[serviceId];
  }

  return useBrandFeatureService;
}
